import React, { useEffect } from "react";
import styles from "../styles/DreamDownloadPage.module.css";

const ANDROID_URL = "https://play.google.com/store/apps/details?id=com.erumgreentech.dream";
const IOS_URL = "https://apps.apple.com/kr/app/id6759493057";

function getStoreUrl(userAgent) {
  if (/android/i.test(userAgent)) {
    return ANDROID_URL;
  }

  if (/iphone|ipad|ipod/i.test(userAgent)) {
    return IOS_URL;
  }

  return null;
}

function DreamDownloadPage() {
  useEffect(() => {
    const storeUrl = getStoreUrl(navigator.userAgent || "");

    if (storeUrl) {
      window.location.replace(storeUrl);
    }
  }, []);

  return (
    <main className={styles.page}>
      <section className={styles.panel} aria-labelledby="download-title">
        <img
          src={`${process.env.PUBLIC_URL}/dream-screenshots/00_logo.png`}
          alt="들어드림"
          className={styles.logo}
        />
        <p className={styles.eyebrow}>APP DOWNLOAD</p>
        <h1 id="download-title" className={styles.title}>
          들어드림 앱 다운로드
        </h1>
        <p className={styles.description}>
          사용 중인 기기에 맞는 스토어로 자동 이동합니다. 이동하지 않으면 아래에서 직접 선택해주세요.
        </p>
        <div className={styles.actions}>
          <a className={styles.primaryButton} href={ANDROID_URL}>
            Google Play
          </a>
          <a className={styles.secondaryButton} href={IOS_URL}>
            App Store
          </a>
        </div>
      </section>
    </main>
  );
}

export default DreamDownloadPage;
